import { Mobile, Tablet, Desktop } from '../styles/Responsive';
import ForgetPasswordForm2 from '../components/forms/ForgetPasswordForm2';
import ImgSlider from '../components/imgSlider/ImgSlider';
import './forgetPassword2.scss';

export default function ForgetPassword(props) {

  console.log('Config : ' + JSON.stringify(process.env));
  return (
    <>
      <Mobile>
        <div className="m-loginContainer">
          <ForgetPasswordForm2 getToken={props.getToken} />
        </div>
      </Mobile>
      <Tablet>
        <div className="t-loginContainer">
          <div className="t-loginContent__grid">
            <ForgetPasswordForm2 getToken={props.getToken} />
            <ImgSlider />
          </div>
        </div>
      </Tablet>
      <Desktop>
        <div className="loginContainer">
          <ImgSlider />
          <ForgetPasswordForm2 getToken={props.getToken} />
        </div>
      </Desktop>
    </>
  );
}
